import * as Sentry from "@sentry/react";

import { ServiceError } from "./httpUtils";

type Primitive = number | string | boolean | bigint | symbol | null | undefined;

interface SentryEventBase {
  level?: Sentry.SeverityLevel;
  tags?: { [key: string]: Primitive };
  extra?: Record<string, unknown>;
}

export interface SentryMessage extends SentryEventBase {
  message: string;
}

export const LogSentryMessage = ({ message, level = "info", tags, extra }: SentryMessage) => {
  return Sentry.captureMessage(message ? `${message}` : `No message provided`, {
    tags,
    extra,
    level,
  });
};

export interface SentryException extends SentryEventBase {
  messagePrefix?: string;
  error: unknown;
}

export const LogSentryException = ({
  messagePrefix,
  error,
  level = "error",
  tags,
  extra,
}: SentryException) => {
  const originalMsg = error instanceof Error ? error.message : `${error}`;
  const msg = messagePrefix ? `${messagePrefix}: ${originalMsg}` : `${originalMsg}`;

  let err: Error;
  if (error instanceof Error) {
    // Without this it is copied by reference, and it modifies the original error object
    err = new Error();
    err.message = msg;
    err.cause = error.cause;
    err.name = error.name;
    err.stack = error.stack;
  } else {
    err = new Error(msg, { cause: error });
  }

  const additionalExtra = { ...extra };

  if (error instanceof ServiceError) {
    additionalExtra.serviceErrorResponse = error.serviceErrorResponse;
  }

  return Sentry.captureException(err, {
    tags,
    extra: additionalExtra,
    level,
  });
};

/**
 * @deprecated Use LogSentryException instead
 */
export const LogSentryEvent = LogSentryException;
